﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadParameterField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadParameterField, eOutputFieldType.cadParameter)
export class CadParameterField extends OutputField implements ICadParameterField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public value: any;
}
